import state from "./moduleDisbursementState.js";
import mutations from "./moduleDisbursementMutations.js";
import actions from "./moduleDisbursementActions.js";
import getters from "./moduleDisbursementGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
